export default "__VITE_ASSET__d24e6e1e__"